// src/components/talks/Talks.jsx
import groupedByYear from "./useBibtexData";
import PublicationPage from "../publications/PublicationPage";
import TalkExplorer from "./TalkExplorer";
import { talkFormat, talkFormats } from "./talkTypes";

const formatLabel = (entry, isPortuguese) => {
  const format = talkFormats.find(([key]) => key === talkFormat(entry));
  return format ? (isPortuguese ? format[1] : format[2]) : null;
};

const isTalk = (pub) => {
  if (!pub) return false;
  const hasTalkAsset = !!(pub.slidesPDF || pub.canvaPresentation || pub.youtubeLink);
  const hasTalkTag = Array.isArray(pub.tags) ? pub.tags.some((t) => /presentation|poster|slides|talk/i.test(t)) : false;
  return hasTalkAsset || hasTalkTag;
};

export default function Talks() {
  return (
    <PublicationPage
      groupedByYear={groupedByYear}
      title="Selected Talks"
      filterFn={isTalk}
      basePath="talks"
      showReference={true}
      explorer={TalkExplorer}
      formatLabel={formatLabel}
    />
  );
}
